import { render, staticRenderFns } from "./Dropdown2.vue?vue&type=template&id=d2b964e8&"
import script from "./Dropdown2.vue?vue&type=script&lang=js&"
export * from "./Dropdown2.vue?vue&type=script&lang=js&"
import style0 from "./Dropdown2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports